
import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import './editor.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';

registerBlockType(metadata.name, {
	icon: {
		src: 'groups',
		background: 'var(--wp--preset--color--white)',
		foreground: 'var(--wp--preset--color--black)'
	},
	edit: Edit,
	save,
});
